import dayjs from 'dayjs'

export const moduleDataSchemas = [
  {
    prop: 'moduleConfigName',
    label: '应用名称',
    minWidth: 60
  },
  // {
  //   prop: 'ybCode',
  //   label: '医保编码',
  //   minWidth: 60
  // },
  {
    prop: 'clientNumber',
    label: '授权客户端数量',
    minWidth: 60
  },
  {
    prop: 'beginTime',
    label: '服务开始时间',
    minWidth: 60
  },
  {
    prop: 'endTime',
    label: '服务结束时间',
    minWidth: 60
  },
  {
    prop: 'modifyTime',
    label: '最后续费时间',
    minWidth: 60
  },
  {
    prop: 'applyStatus',
    label: '版本状态',
    minWidth: 80
  },
  {
    prop: 'approvalStatus',
    label: '审批进度',
    minWidth: 80
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 160,
    btnArr: ['update', 'approval', 'delete']
  }
]

// const validateStartDate = (rule, value, callback) => {
//   const today = new Date()
//   today.setHours(0, 0, 0, 0)

//   const start = new Date(value[0])

//   if (+dayjs(today) - +dayjs(start) > 0) {
//     callback(new Error('开始时间不能早于当前时间'))
//   } else {
//     callback()
//   }
// }

export const tableDataSchemas = [
  {
    prop: 'name',
    label: '加密狗编号',
    minWidth: 80
  },
  // {
  //   prop: 'moduleConfigName',
  //   label: '授权版本',
  //   minWidth: 80
  // },
  // {
  //   prop: 'contactName',
  //   label: '联系人姓名',
  //   minWidth: 120
  // },
  // {
  //   prop: 'mobile',
  //   label: '安全手机',
  //   minWidth: 120
  // },
  {
    prop: 'clinicName',
    label: '门诊名称',
    minWidth: 100
  },
  // {
  //   prop: 'tenantName',
  //   label: '租户名称',
  //   minWidth: 120
  // },
  // {
  //   prop: 'clientNumber',
  //   label: '授权客户端数量',
  //   minWidth: 60
  // },
  // {
  //   prop: 'beginTime',
  //   label: '服务开始时间',
  //   minWidth: 60
  // },
  // {
  //   prop: 'endTime',
  //   label: '服务结束时间',
  //   minWidth: 60
  // },
  // {
  //   prop: 'lastPayTime',
  //   label: '最后续费时间',
  //   minWidth: 60
  // },
  // {
  //   prop: 'accountStatus',
  //   label: '账号状态',
  //   minWidth: 80
  // },
  {
    prop: 'action',
    label: '操作',
    minWidth: 160,
    btnArr: ['auth', 'info', 'update', 'delete']
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '加密狗编号',
    placeholder: '请输入加密狗编号,提交后不能再修改',
    rules: [
      {
        required: true,
        message: '加密狗编号不能为空'
      }
    ]
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '备注信息',
    placeholder: '请输入备注信息',
    rules: []
  },
  {
    field: 'contactName',
    defaultValue: '',
    component: 'Input',
    label: '联系人姓名',
    placeholder: '请输入联系人姓名',
    rules: [
      {
        pattern: /^[\u4e00-\u9fa5]{2,4}(·[\u4e00-\u9fa5]{2,4})?|^[a-zA-Z.s]{2,20}/,
        message: '姓名格式不正确'
      }
    ]
  },
  {
    field: 'mobile',
    defaultValue: '',
    component: 'Input',
    label: '安全手机',
    placeholder: '请输入安全手机',
    rules: [
      {
        pattern: /^1[3-9][0-9]{9}$/,
        message: '安全手机格式不正确'
      }
    ]
  },

  {
    field: 'clinic',
    defaultValue: '',
    component: 'Cascader',
    label: '诊所',
    placeholder: '请选择诊所',
    rules: [
      {
        required: true,
        message: '请选择诊所'
      }
    ]
  }
  // {
  //   field: 'type',
  //   defaultValue: 1,
  //   component: 'Radio',
  //   label: '所属模块类型',
  //   placeholder: '请选择所属模块类型',
  //   radioArr: [
  //     {
  //       label: '平台管理系统',
  //       value: 1
  //     },
  //     {
  //       label: 'his管理系统',
  //       value: 2
  //     }
  //   ],
  //   rules: []
  // }
  // {
  //   field: 'authTime',
  //   defaultValue: '',
  //   component: 'DateInterval',
  //   label: '授权时间',
  //   placeholder: '请选择授权时间',
  //   radioArr: [],
  //   rules: [
  //     {
  //       required: true,
  //       message: '授权时间不能为空'
  //     }
  //   ]
  // },
  // {
  //   field: 'moduleConfig',
  //   defaultValue: '',
  //   component: 'Radio',
  //   label: '应用配置',
  //   placeholder: '请选择应用配置',
  //   radioArr: [],
  //   rules: [
  //     {
  //       required: true,
  //       message: '请选择一个应用不能为空'
  //     }
  //   ]
  // }
]

export const applyApprovalTypes = [
  {
    value: 2,
    label: '到期续费'
  },
  {
    value: 3,
    label: '申请功能升级'
  },
  { value: 4, label: '续费和功能升级' },
  { value: 5, label: '其他' }
]

// 基础设置 form
export const authFormSchemas = [
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '授权版本',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请输入授权版本'
      }
    ]
  },
  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '服务时间',
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
      // {
      //   validator: validateStartDate
      // }
    ]
  },
  // {
  //   field: 'lastPayTime',
  //   defaultValue: '',
  //   component: 'Date',
  //   label: '最后续费时间',
  //   placeholder: '请选择最后续费时间',
  //   rules: [
  //     {
  //       required: true,
  //       message: '最后续费时间不能为空'
  //     }
  //   ]
  // },
  // {
  //   field: 'applyStatus',
  //   defaultValue: 1,
  //   component: 'Switch',
  //   label: '版本状态',
  //   rules: []
  // },
  {
    field: 'clientNumber',
    type: 'number',
    defaultValue: '',
    component: 'Input',
    label: '授权客户端数量',
    placeholder: '请输入授权客户端数量',
    rules: []
  },

  {
    field: 'province',
    defaultValue: '',
    component: 'Select',
    label: '请选择省份',
    selectArr: [
      {
        label: '海南',
        value: 7
      },
      {
        label: '陕西',
        value: 9
      },
      {
        label: '黑龙江',
        value: 10
      },
      {
        label: '浙江',
        value: 11
      },
      {
        label: '广东',
        value: 12
      },
      {
        label: '安徽',
        value: 15
      }
    ],
    rules: [
      {
        required: true,
        message: '请选择省份'
      }
    ]
  },
  {
    field: 'ybCode',
    defaultValue: '',
    component: 'Input',
    placeholder: '请输入医保编码(如果医保省份是浙江，请在医保编码后带上ZS)',
    label: '医保编码',
    rules: [
      {
        required: true,
        message: '请填写医保编码'
      }
    ]
  },
  {
    field: 'applyApprovalType',
    defaultValue: '',
    component: 'Select',
    label: '操作说明',
    selectArr: applyApprovalTypes,
    rules: [
      {
        required: true,
        message: '操作说明不能为空'
      }
    ]
  }
]

// 修改设置 form
export const updateFormSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '租户名'
  },
  {
    field: 'clinicName',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '诊所名'
  },
  {
    field: 'type',
    defaultValue: 1,
    component: 'Radio',
    label: '所属模块类型',
    disabled: true,
    placeholder: '请选择所属模块类型',
    radioArr: [
      {
        label: '平台管理系统',
        value: 1
      },
      {
        label: 'his管理系统',
        value: 2
      }
    ],
    rules: []
  },
  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '应用配置',
    placeholder: '请选择应用配置',
    disabled: true,
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请选择一个应用不能为空'
      }
    ]
  }
]

/* eslint-disable */
export const ApplyType = {
  [1]: '首次申请开通应用',
  [2]: '到期续费',
  [3]: '申请功能升级',
  [4]: '续费和功能升级',
  [5]: '其他'
}

export const shortcuts = [
  {
    text: '一年',
    value: () => {
      const start = new Date()
      const end = +dayjs(start.getTime()).add(1, 'year')
      return [start, end]
    }
  },
  {
    text: '两年',
    value: () => {
      const start = new Date()
      const end = +dayjs(start.getTime()).add(2, 'year')
      return [start, end]
    }
  },
  {
    text: '五年',
    value: () => {
      const start = new Date()
      const end = +dayjs(start.getTime()).add(5, 'year')
      return [start, end]
    }
  },
  {
    text: '九九年',
    value: () => {
      const start = new Date()
      const end = +dayjs(start.getTime()).add(99, 'year')
      return [start, end]
    }
  }
]

export const options = []
